var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlakyIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40.4,
    viewBox: "0 0 40 40.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "checkmark-circle"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1823",
    "data-name": "Rectangle 1823",
    width: 40,
    height: 40,
    fill: "none",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_8533",
    "data-name": "Group 8533",
    transform: "translate(3 4)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1824",
    "data-name": "Rectangle 1824",
    width: 33,
    height: 33,
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_8534",
    "data-name": "Group 8534"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_454",
    "data-name": "Line 454",
    y2: 18,
    transform: "translate(17 8)",
    fill: "none",
    stroke: "#e57300",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_455",
    "data-name": "Line 455",
    x2: 14.55,
    y2: 8.401,
    transform: "translate(9.525 12.602)",
    fill: "none",
    stroke: "#e57300",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_456",
    "data-name": "Line 456",
    y1: 8.401,
    x2: 14.55,
    transform: "translate(9.525 12.602)",
    fill: "none",
    stroke: "#e57300",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8535",
    "data-name": "Group 8535"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_922",
    "data-name": "Path 922",
    d: "M104,40l3.15,3.15L110.3,40",
    transform: "translate(-90.35 -39.568)",
    fill: "none",
    stroke: "#e57300",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_923",
    "data-name": "Path 923",
    d: "M104,195.15l3.15-3.15,3.15,3.15",
    transform: "translate(-90.35 -161.578)",
    fill: "none",
    stroke: "#e57300",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_924",
    "data-name": "Path 924",
    d: "M39.79,68.671l4.3-1.153-1.153-4.3",
    transform: "translate(-38.385 -57.125)",
    fill: "none",
    stroke: "#e57300",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_925",
    "data-name": "Path 925",
    d: "M184.579,156.671l-1.153-4.3,4.3-1.153",
    transform: "translate(-155.531 -129.158)",
    fill: "none",
    stroke: "#e57300",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_926",
    "data-name": "Path 926",
    d: "M42.94,156.671l1.153-4.3-4.3-1.153",
    transform: "translate(-38.385 -129.756)",
    fill: "none",
    stroke: "#e57300",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_927",
    "data-name": "Path 927",
    d: "M187.729,68.671l-4.3-1.153,1.153-4.3",
    transform: "translate(-155.531 -57.527)",
    fill: "none",
    stroke: "#e57300",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlakyIcon);
export default __webpack_public_path__ + "static/media/FlakyIcon.88b9996371492a0d4d4c13ade74f69d0.svg";
export { ForwardRef as ReactComponent };